export const DETAIL_PRODUIT_RESEAU_MAIRIE = {
  title: 'Détail produit réseau mairie {libelle}',
  breadcrumb: 'Détail produit réseau mairie {libelle}',
  onglet: {
    product: 'Produit',
    face: 'Faces associées',
    productAssocie: 'Produits associés',
    affectation: 'Affectations',
  },
  archivageDesarchiver: {
    archivage: 'Etes-vous sûr de vouloir archiver ce produit ?',
    desarchivage: 'Etes-vous sûr de vouloir désarchiver ce produit ?',
  },
  messages: {
    success: {
      archivage: 'Produit réseau mairie archivé avec succès.',
      desarchivage: 'Produit réseau mairie désarchivé avec succès.',
    },
  },
  libelleProduitMairieForLogo: 'Produit réseau mairie {ref}',
};

export const AJOUT_RESEAU_MAIRIE_DCF = {
  title: 'Ajouter un réseau mairie',
  brief: 'Mon brief',
  panier: 'Panier',
  table: {
    codeReseau: 'Code réseau',
    libelle: 'Libellé',
    type: 'Type',
    zipCode: 'CP',
    city: 'Ville',
    format: 'Format',
    societe: 'Société',
  },
  briefContent: {
    reseauConfrere: 'Inclure réseaux confrères',
    codeReseau: 'Code(s) réseau',
    villes: 'Ville(s) réseau',
    departements: 'Département',
    libelle: 'Libellé',
    formats: 'Format',
    budgetMax: 'Budget max',
    societe: 'Société',
  },
};
